"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _material = require("@mui/material");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _Card = require("../Card");

var _TextField = require("../TextField");

var _TextButton = require("../TextButton");

var _Typography = require("../Typography");

var _IconButton = require("../IconButton");

var _theme = require("../../theme");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ExpandableFilter = function ExpandableFilter(_ref) {
  var _SwipeableDrawerProps;

  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "card" : _ref$variant,
      filterLabel = _ref.filterLabel,
      filterLabelProps = _ref.filterLabelProps,
      filterValues = _ref.filterValues,
      showLabel = _ref.showLabel,
      hideLabel = _ref.hideLabel,
      resetLabel = _ref.resetLabel,
      searchProps = _ref.searchProps,
      filterControlsRightContent = _ref.filterControlsRightContent,
      FilterControlsBoxProps = _ref.FilterControlsBoxProps,
      SwipeableDrawerProps = _ref.SwipeableDrawerProps,
      onReset = _ref.onReset,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showFilters = _useState2[0],
      setShowFilters = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isDirty = _useState4[0],
      setIsDirty = _useState4[1];

  (0, _react.useEffect)(function () {
    for (var filter in filterValues) {
      var _filterValues = filterValues[filter],
          initialValues = _filterValues.initialValues,
          currentValues = _filterValues.currentValues;

      if (!(0, _lodash.default)(initialValues, currentValues)) {
        setIsDirty(true);
        return;
      }
    }

    setIsDirty(false);
  }, [filterValues]);
  var handleReset = (0, _react.useCallback)(function () {
    setIsDirty(false);
    onReset();
  }, [onReset]);
  var resetButton = /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
    disabled: !isDirty,
    label: resetLabel,
    onClick: handleReset,
    variant: "outlined"
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, _objectSpread(_objectSpread({}, FilterControlsBoxProps), {}, {
      sx: _objectSpread({
        display: "flex",
        alignItems: "center",
        px: 4,
        py: 3,
        width: "100%"
      }, FilterControlsBoxProps === null || FilterControlsBoxProps === void 0 ? void 0 : FilterControlsBoxProps.sx),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.TextField, _objectSpread({}, searchProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        component: "span",
        mr: 3
      }), variant === "card" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
        iconLeft: "filter",
        iconLeftColor: isDirty ? _theme.palette.primary.main : _theme.palette.brand.grey.stone,
        label: showFilters ? hideLabel : showLabel,
        onClick: function onClick() {
          return setShowFilters(!showFilters);
        },
        variant: "outlined"
      }), variant === "drawer" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
        iconName: "filter",
        color: isDirty ? "primary" : "default",
        "aria-label": showFilters ? hideLabel : showLabel,
        onClick: function onClick() {
          return setShowFilters(!showFilters);
        },
        variant: "outlined"
      }), filterControlsRightContent]
    })), variant === "card" && showFilters && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        alignItems: "flex-end",
        display: "flex",
        flexWrap: "wrap",
        px: 4,
        py: 3,
        sx: (0, _defineProperty2.default)({}, "&.".concat(_utilities.classes.components.MuiBox.root, " > *"), {
          marginRight: function marginRight(theme) {
            return theme.spacing(3);
          }
        }),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, _objectSpread(_objectSpread({}, filterLabelProps), {}, {
          color: "inherit",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
            children: filterLabel
          })
        })), children, resetButton]
      })]
    }), variant === "drawer" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.SwipeableDrawer, _objectSpread(_objectSpread({
      anchor: "left",
      variant: "temporary",
      keepMounted: true,
      hideBackdrop: true,
      open: showFilters,
      onOpen: function onOpen() {
        return setShowFilters(true);
      },
      onClose: function onClose() {
        return setShowFilters(false);
      }
    }, SwipeableDrawerProps), {}, {
      PaperProps: _objectSpread(_objectSpread({}, SwipeableDrawerProps === null || SwipeableDrawerProps === void 0 ? void 0 : SwipeableDrawerProps.PaperProps), {}, {
        sx: _objectSpread((0, _defineProperty2.default)({
          minWidth: "12rem",
          padding: 3,
          "& > div:not(:last-child)": {
            mb: 3
          }
        }, "& .".concat(_utilities.classes.components.MuiInput.root), {
          width: "100%"
        }), SwipeableDrawerProps === null || SwipeableDrawerProps === void 0 ? void 0 : (_SwipeableDrawerProps = SwipeableDrawerProps.PaperProps) === null || _SwipeableDrawerProps === void 0 ? void 0 : _SwipeableDrawerProps.sx)
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
        "aria-label": hideLabel,
        borderless: true,
        iconName: "times",
        sx: {
          ml: "auto"
        },
        onClick: function onClick() {
          return setShowFilters(false);
        }
      }), children, resetButton]
    }))]
  });
};

var _default = ExpandableFilter;
exports.default = _default;